function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#blob-5_svg__filter0_d)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  clipPath: "url(#blob-5_svg__clip0)"
}, React.createElement("path", {
  opacity: 0.2,
  d: "M132.018 67.777c20.929-16.494 51.601-21.426 77.11-13.722 24.33 7.347 35.728 34.024 52.713 52.929 13.069 14.547 25.562 28.369 35.473 45.227 11.577 19.694 28.837 38.602 27.204 61.388-1.67 23.297-17.48 44.092-35.804 58.576-17.185 13.583-40.346 13.49-61.677 18.471-21.12 4.933-41.313 13.103-62.858 10.611-25.187-2.913-52.05-7.909-69.858-25.959-18.436-18.687-28.552-46.054-27.046-72.261 1.436-24.977 24.119-42.147 34.92-64.713 11.25-23.505 9.356-54.418 29.823-70.547z",
  fill: "#7C94A1"
}), React.createElement("path", {
  d: "M205.287 51.948c26.372-3.82 55.401 7.245 73.641 26.671 17.396 18.528 13.929 47.329 19.185 72.195 4.045 19.133 7.953 37.349 8.107 56.904.18 22.844 5.673 47.849-7.134 66.765-13.095 19.341-37.184 29.446-60.295 32.826-21.674 3.171-41.686-8.49-62.65-14.841-20.756-6.289-42.329-9.31-59.742-22.24-20.356-15.116-41.122-32.875-47.519-57.41-6.622-25.401-1.7-54.16 12.708-76.103 13.732-20.913 41.961-24.442 62.598-38.584 21.496-14.73 35.312-42.449 61.101-46.183z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "blob-5_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h375v375H0V0z",
  fill: "#fff"
})), React.createElement("filter", {
  id: "blob-5_svg__filter0_d",
  x: -21,
  y: 8,
  width: 401.523,
  height: 407.045,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 24
}), React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.729412 0 0 0 0 0.764706 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  mode: "multiply",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgBlob5(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 375 375",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgBlob5;